import {extendObservable} from 'mobx'
import firebase from '../firebase'
//TODO: import Logger from './Logger'

class NotificationStore {
    constructor(authStore) {
        extendObservable(this, {
            notifications: null,
            newNotifications: false,
        })
        this.authStore = authStore

        this.unwatchAuth = authStore.watchAuth(user => {
            if(user){
                this.loadMyNotifications()
            }else{
                this.logout()
            }
        })
    }
    logout(){
        const authUser = this.authStore.authUser()
        const rootRef = firebase.database().ref()

        if (authUser){
            rootRef.child('notifications/'+authUser.uid).off()
        }

        this.notifications = []
        this.newNotifications = false
    }
    saveMessagingDeviceToken(){
        let thing = this
        firebase.messaging().getToken().then(function (currentToken) {
            if (currentToken) {
                // console.log('Got FCM device token:', currentToken)
                // Saving the Device Token to the datastore.
                firebase.database().ref('/fcmTokens').child(currentToken)
                    .set(firebase.auth().currentUser.uid)
            } else {
                // Need to request permissions to show notifications.
                thing.requestNotificationsPermissions()
            }
        }).catch(function (error){
          console.error('Unable to get messaging token.', error)
        })
    }
    //TODO: handle onTokenRefresh, see https://firebase.google.com/docs/reference/js/firebase.messaging.Messaging#onMessage
    requestNotificationsPermissions(){
        let thing = this
        console.log('Requesting notifications permission...')
        firebase.messaging().requestPermission().then(function () {
            // Notification permission granted.
            thing.saveMessagingDeviceToken()
        }).catch(function (error) {
            console.error('Unable to get permission to notify.', error)
        })
    }
    loadMyNotifications(){
        const authUser = this.authStore.authUser()
        firebase.database().ref().child('notifications/'+authUser.uid).orderByKey().limitToLast(10).on('value', snap => {
            this.notifications = snap.val()
            this.newNotifications = false
            for (let z in this.notifications){
                if (!this.notifications[z].delivered){
                    this.newNotifications = true
                }
            }
        })
    }
    markMyNotificationsAsDelivered(){
        const authUser = this.authStore.authUser()
        firebase.database().ref().child('notifications/'+authUser.uid).orderByKey().limitToLast(10).once('value', snap => {
            snap.forEach(notif => {
                notif.ref.update({
                    delivered : true,
                })
            })
        })
    }
    clearMyNotifications(){
        const authUser = this.authStore.authUser()
        firebase.database().ref().child('notifications/'+authUser.uid).orderByKey().once('value')
        .then(snap => {
            snap.forEach(elem => {
                elem.ref.remove()
            })
        })
    }
    createNotificationToTeamMembers(ideaKey, message, owner, team, responsible, loadedTeam){
        const authUser = this.authStore.authUser()
        let ownerKey = ''
        let thing = this
        if(owner){
            firebase.database().ref().child('users').orderByChild('email').equalTo(owner).once('value').then(snap => { //TODO: maybe use findUserByEmail in auth
                if (snap.exists()) {
                    ownerKey = Object.keys(snap.val())
                    if (authUser.uid !== ownerKey[0]){
                        this.createNotification(ideaKey, ownerKey[0], message)
                    }
                    if (responsible){
                        this.createNotification(ideaKey, responsible.userId, message)
                    }
                    if(!team)
                    return //no team, so no-one to notify
                    team.forEach(function (aTeam) {
                        if (aTeam.hasOwnProperty('userId')) {
                            if (aTeam.userId !== authUser.uid){
                                thing.createNotification(ideaKey, aTeam.userId, message)
                            }
                        }
                        else if (aTeam.hasOwnProperty('email')) {
                            //TODO: existing team-members without userId in idea-team, will not get notified (or maybe via email)
                        }
                    })
                }
            })
        }
    }
    createNotificationToTeamMembersInTeam(teamKey, message, userId){
        const authUser = this.authStore.authUser()
        let redirect = '/team'
        let notificationMessage = message
        let notificationType = 'team'
        firebase.database().ref().child('teams').child(teamKey).once('value').then(teamSnap => {
            let teamObj = teamSnap.val()
            if (teamObj.hasOwnProperty('members')) {
                Object.keys(teamObj.members).forEach(teamMemberId => {
                    if (teamMemberId !== authUser.uid){
                        if (teamMemberId === userId){
                            redirect = '/ideas/'
                            notificationMessage = authUser.displayName + ' removed you from the team ' + teamObj.name
                            notificationType = 'personal'
                        }
                        let notif = {
                            title: 'Team message',
                            body: notificationMessage,
                            click_action: redirect,
                            delivered: false,
                            timestamp: firebase.database.ServerValue.TIMESTAMP,
                            icon: authUser.photoURL,
                            notifType: notificationType,
                        }
                        firebase.database().ref().child('notifications/').child(teamMemberId).push(notif)
                    }
                })
            }
        })
    }
    createNotification(ideaKey, toUserId, body) {
        const authUser = this.authStore.authUser()
        if(ideaKey && authUser.uid !== toUserId){
            firebase.database().ref().child('ideas').child(ideaKey).child('name').once('value')
            .then(snap => {
                let ideaName = snap.val()
                let notif = {
                    title: 'On '+ideaName,
                    body: body,
                    click_action: '/idea/' + ideaKey+ '/view',
                    delivered: false,
                    timestamp: firebase.database.ServerValue.TIMESTAMP,
                    icon: authUser.photoURL,
                    notifType: 'other',
                }
                firebase.database().ref().child('notifications/').child(toUserId).push(notif)
            })
        }
    }
    createNotificationAboutJoinedTeam(teamName, toUserId, body, notificationType) {
        let defaultType = 'team'
        if (notificationType !== undefined){
            defaultType = notificationType
        }
        const authUser = this.authStore.authUser()
        let notif = {
            title: 'Team '+teamName,
            body: body,
            click_action: '/team',
            delivered: false,
            timestamp: firebase.database.ServerValue.TIMESTAMP,
            icon: authUser.photoURL,
            notifType: defaultType,
        }
        firebase.database().ref().child('notifications/').child(toUserId).push(notif)
    }
}

export default NotificationStore


// WEBPACK FOOTER //
// ./src/stores/NotificationStore.js